export default "__VITE_ASSET__CLD6IeUD__"